import React, {useContext} from "react";
import {createContext, useEffect, useState} from "react";

export const UserConfigContext = createContext({});

async function getData(url = '', data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
    });
    return response.json(); // parses JSON response into native JavaScript objects
}

export default function UserConfigContextProvider({children})
{
    const [userConfig, setUserConfig] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const queryString = window.location.search;
        const UrlParams = new URLSearchParams(queryString);
        if (UrlParams.has('mail') && UrlParams.has('hash')) {

            const configUrl = 'https://www.cinedream.be/designer/getconfig?mail=' + UrlParams.get('mail') + '&hash=' + UrlParams.get('hash');

            getData(configUrl)
                .then(data => {
                    setUserConfig(data['data'][0])
                    setIsLoaded(true);
                });

        }
        else {
            setIsLoaded(true);
        }
    }, []);

    return (
        <UserConfigContext.Provider value={{userConfig}}>
            {isLoaded ? children : <></>}
        </UserConfigContext.Provider>
    )
}

export const useUserConfigContext = () => useContext(UserConfigContext);
